import React from "react";

export const GrayBox = () => {
  return (
    <div className="empty_box  ">
      <div className="title_box mb_26 d-flex  justify-content-between">
        <div className="boxtop_left  "></div>
        <div className="boxtop_right "></div>
      </div>
      <div className="body_box mb_32">
        <div className="head_box  mb_12"> </div>
        <div className="content_box_inner d-flex  justify-content-between">
          <div className="box_50  mb_8  "></div>
        </div>
        <div className="content_box_inner d-flex  justify-content-between">
          <div className="box_60  mb_10"></div>
        </div>
      </div>
      <div className="body_box mb_32">
        <div className="head_box  mb_12"> </div>
        <div className="content_box_inner d-flex  justify-content-between">
          <div className="box_50  mb_8"></div>
        </div>
        <div className="content_box_inner d-flex  justify-content-between">
          <div className="box_60 mb_8"></div>
        </div>
      </div>
      <div className="body_box mb_32">
        <div className="head_box  mb_12"> </div>
        <div className="content_box_inner d-flex  justify-content-between">
          <div className="box_50  mb_8"></div>
        </div>
        <div className="content_box_inner d-flex  justify-content-between">
          <div className="box_60 mb_10"></div>
        </div>
        {/* <div className="content_box_inner d-flex  justify-content-between">
        <div className="box_50 mb_10"></div>
        <div className="box_50 mb_10"></div>
      </div> */}
      </div>
    </div>
  );
};
